/**
 * File containing common methods for addon widgets, namespaced under
 * miraGlobal.addons
 */
(() => {
  const miraObject = window.miraGlobal || {};

  miraObject.addons = {
    ...miraObject.addons,

    /**
     * Dispatch close event for new mira overlay
     */
    closeMiraModal: () => {
      miraGlobal?.events?.overlayEventBus?.dispatchEvent(
        new CustomEvent('close', {
          detail: {
            overlayId: 'upsell_modal',
          },
        }),
      );
    },

    /**
     * Dispatches event to reload upsell carousel
     */
    reloadMiraCarouselButtons: () => {
      miraGlobal?.events?.carouselEventBus?.dispatchEvent(new CustomEvent('reload'));
    },

    /**
     * Removes addon item from carousel
     */
    removeMiraItemFromCarousel: (eventTarget) => {
      const parent = eventTarget.closest('.addon');

      parent.remove();

      miraGlobal.addons.reloadMiraCarouselButtons();
    },

    /**
     * Marks an addon button as added (success state) instead of removing the
     * item, so the user gets visual confirmation it was added
     */
    markAddonButtonAsAdded: (button, succeeded) => {
      if (!succeeded) return;

      button.classList.add('is-added');
      button.disabled = true;

      button.innerHTML = `
        <span>Added</span>
        <svg class="addon__added-icon" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
          <path d="M3 8.5L6.5 12L13 4.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      `;
    },
  };

  window.miraGlobal = miraObject;
})();
